import * as actions from './actions'
import {Map,  List, fromJS} from 'immutable';


function reducer(
        state=Map({
            isFetching: false,
            items: List(),
            currentItem: null,
            currentList: null
        }),action) {
    switch (action.type) {
        // ========= READ =========== NEED TO ARRANGE INDEX WHEN WE GET IT FROM BACKEND
        case actions.TUTORIAL_READ_SUCCESS:
            return state
                    .set('isFetching', false)
                    .set('items', List(fromJS(
                        [
                            {
                                container: 'Kom igång med Jibber',
                                done: false,
                                items: List(fromJS([
                                    {header: 'Välj färg på chatten', text: 'Försök hitta en färg som passar din hemsida!', done: false, id: 0},
                                    {header: 'Skapa ett automeddelande', text: 'Skräddarsy ert egna meddelande', done: false, id: 1},
                                    {header: 'Swisha Tuan', text: 'Glöm inte betala till Tuan!', done: false, id: 2}
                                ]))
                            },
                            {
                                container: 'Kom igång med Jibber',
                                done: false,
                                items: List(fromJS([
                                    {header: 'Välj färg på chatten', text: 'Försök hitta en färg som passar din hemsida!', done: false, id: 3},
                                    {header: 'Skapa ett automeddelande', text: 'Skräddarsy ert egna meddelande', done: false, id: 4},
                                    {header: 'Swisha Tuan', text: 'Glöm inte betala till Tuan!', done: false, id: 5}
                                ]))
                            }
                        ])
                    ))
        case actions.TUTORIAL_SET_CURRENT_ITEM:
            return state
                    .set('currentItem', action.id)

        case actions.TUTORIAL_SET_CURRENT_LIST:
            return state
                    .set('currentList', action.id)
        case actions.TUTORIAL_SET_TO_DONE:
        //console.log('statee', state.getIn(['items', action.listId]));
            return state
                    .setIn(['items', action.listId, 'items', action.itemId, 'done'], true);
        default:
            return state

      }
}


export default reducer



// WEBPACK FOOTER //
// ./src/model/Tutorial/reducer.js